import { LuBedDouble, LuBath, LuCar, LuHeart } from "react-icons/lu";
import { Property } from "../../types/Property.interface";
import { useFeature } from "../../hooks/useFeature";
import useStore, { StoreState } from "../../context/useStore";
import React from "react";

interface BodyProps {
  property: Property;
}

const Body: React.FC<BodyProps> = ({ property }) => {
  const { onFeature } = useFeature(property);
  const auth = useStore((state: StoreState) => state.auth);
  const featured = useStore((state: StoreState) => state.properties);

  return (
    <div
      className={`px-2 py-3 ${
        property.Lock && !auth.login
          ? "blur"
          : property.Lock && auth.login && !auth.verify
          ? "blur"
          : ""
      }`}
    >
      <div className="flex justify-between items-center mb-2">
        <span className="text-sm font-normal line-clamp-1">
          {property.UnparsedAddress
            ? property.UnparsedAddress
            : property.StreetName +
              " " +
              property.StreetNumber +
              " " +
              property.StreetSuffix +
              " " +
              property.City 
}
        </span>
        <div className="flex justify-center items-center text-red-600 text-2xl">
          {(auth.login === true && (
            <>
              {(featured.includes(property.ListingKey) && (
                <LuHeart
                  className="fill-current"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    onFeature();
                  }}
                />
              )) || (
                <LuHeart
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    onFeature();
                  }}
                />
              )}
            </>
          )) || (
            <LuHeart
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                onFeature();
              }}
            />
          )}
        </div>
      </div>

      <div className="flex justify-between items-center py-1">
        <div className="text-[0.875rem] font-normal text-gray-800 flex justify-start items-center space-x-4">
          <span className="flex justify-center items-center gap-1">
            {property.BedroomsTotal >= "1" ? (
              <>
                {property.BedroomsTotal} <LuBedDouble className="text-lg" />
              </>
            ) : property.BedroomsTotal === "0" ? (
              <>
                {"0"} <LuBedDouble className="text-lg" />
              </>
            ) : (
              <></>
            )}
          </span>
          <div className="w-px h-4 bg-gray-500" />
          <span className="flex justify-center items-center gap-1">
            {property.BathroomsTotalInteger >= "1" ? (
              <>
                {property.BathroomsTotalInteger} <LuBath className="text-lg" />
              </>
            ) : property.BathroomsTotalInteger === "0" ? (
              <>
                {"0"} <LuBath className="text-lg" />
              </>
            ) : (
              <></>
            )}
          </span>
          <div className="w-px h-4 bg-gray-500" />
          <span className="flex justify-center items-center gap-1">
            {Number(property.ParkingTotal)} <LuCar className="text-xl" />
          </span>
        </div>
      </div>
    </div>
  );
};

export default React.memo(Body);
